import { useState } from "react";
import api from "@/lib/api";
import { ThumbsUp } from "@/components/icons";

export default function LikeButton({ entityType, entityId, authorId, clienteId, dealId, label, count = 0, liked = false }) {
  const [c, setC] = useState(count);
  const [l, setL] = useState(liked);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    setL((v) => !v);
    setC((n) => n + (l ? -1 : 1));
    try {
      const { data } = await api.post("/reacoes/toggle", {
        entity_type: entityType, entity_id: entityId, author_id: authorId,
        cliente_id: clienteId, deal_id: dealId, label,
      });
      setL(data.liked);
      setC(data.count);
    } catch {
      setL((v) => !v);
      setC((n) => n + (l ? 1 : -1));
    } finally { setBusy(false); }
  };

  return (
    <button onClick={toggle} disabled={busy} data-testid={`like-${entityId}`}
      className={`inline-flex items-center gap-1 text-xs rounded-full px-2 py-1 transition-colors ${l ? "bg-brand-soft/60 text-brand" : "text-muted-foreground hover:bg-slate-100"}`}
      title={l ? "Remover curtida" : "Curtir"}>
      <ThumbsUp className={`w-3.5 h-3.5 ${l ? "fill-brand text-brand" : ""}`} />
      {c > 0 && <span className="font-semibold">{c}</span>}
    </button>
  );
}
